import { Grid, makeStyles, Typography } from "@material-ui/core";
import { COLORS } from "../../theme/colors";
import { Icon } from "../base/Icon";

const useStyles = makeStyles((theme) => ({
  table: {
    border: `1px solid ${COLORS.darks[0][10]}`,
    borderRadius: 8,
    overflow: "hidden",
  },
  header: {
    backgroundColor: COLORS.darks[0][6],
  },
  tableContent: {
    maxHeight: (props) => props.maxHeight || 400,
    overflow: "auto",
  },
  cell: {
    padding: `${theme.spacing(1.5)}px ${theme.spacing(3)}px`,
    display: "flex",
    alignItems: "center",
  },
  iconContainer: {
    height: "100%",
    paddingRight: theme.spacing(3),
  },
  icon: {
    width: (props) => props.endIconWidth || 12,
  },
}));

export const Table = ({
  headers,
  data,
  colWidths,
  colWidthsVariable,
  endIcon,
  cellStyles,
  endIconWidth,
  cellPaddingRight,
  maxHeight,
  onEndIconClick,
  onRowClick,
  id,
  rowStyles,
  activeStatuses,
}) => {
  const classes = useStyles({ endIconWidth, maxHeight });

  return (
    <div className={classes.table} id={id}>
      {/* Header row */}
      <Grid className={classes.header} container>
        {headers?.map((header, index) => (
          <Grid
            className={classes.cell}
            key={index}
            item
            style={{
              width: `${colWidths[index]}%`,
              ...(cellStyles ? cellStyles[index] : null),
              paddingRight: cellPaddingRight,
            }}
          >
            {typeof header === "string" ? <Typography>{header}</Typography> : header}
          </Grid>
        ))}
      </Grid>

      {/* Content table */}
      <div className={classes.tableContent}>
        {data.map((row, index_row) => (
          <Grid
            key={index_row}
            container
            style={{
              borderTop: `1px solid ${COLORS.darks[0][10]}`,
              ...(rowStyles ? rowStyles[index_row] : null),
            }}
            onClick={() => {
              if (onRowClick && typeof onRowClick == "function") {
                onRowClick(index_row);
              }
            }}
          >
            {row.map((v, index) => (
              <Grid
                className={classes.cell}
                key={index}
                item
                style={{
                  width: `${
                    colWidthsVariable?.length > index_row
                      ? colWidthsVariable[index_row][index]
                      : colWidths[index]
                  }%`,
                  ...(cellStyles ? cellStyles[index] : null),
                  paddingRight: cellPaddingRight,
                }}
              >
                {typeof v === "string" ? <Typography>{v}</Typography> : v}
              </Grid>
            ))}
            {endIcon && (
              <Grid
                item
                style={{
                  width: `${colWidths[colWidths.length - 1]}%`,
                }}
              >
                <Grid
                  className={classes.iconContainer}
                  container
                  justifyContent="flex-end"
                  alignItems="center"
                >
                  <Icon
                    root={classes.icon}
                    src={endIcon}
                    style={{
                      display: activeStatuses.length
                        ? activeStatuses[index_row]
                          ? "block"
                          : "none"
                        : null,
                    }}
                    hoverable
                    onClick={() => onEndIconClick(index_row)}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        ))}
      </div>
    </div>
  );
};

Table.defaultProps = {
  activeStatuses: [],
};
